// extracted by mini-css-extract-plugin
export default {"task":"FailureViewWorkbookTasksSection_task__aJCRL"};